import UtilService from "./util.service";
import { SCRIPTS } from "../constants/staticScripts";
import GlobalStoreService from "./global-store.service";
import { globalConstants } from "../constants/globalConstants";

const handleReadReturnFromDB = ({ data, message_comp, status, readOnScroll }) => {

    let chatHistoryOldMessages = message_comp.state.chatHistoryMessages
    let chatHistoryNewMessages = []

    if (data && data.length > 0) {

        let historyMessageDateObject = createHistoryMessageDateArray(data, chatHistoryOldMessages)

        chatHistoryNewMessages = historyMessageDateObject.chatHistoryNewMessages
        chatHistoryOldMessages = historyMessageDateObject.chatHistoryOldMessages

        message_comp.setState({ chatHistoryMessages: [...chatHistoryNewMessages, ...chatHistoryOldMessages] })
    }
    message_comp.setLoaderOff();

    if (!readOnScroll) {

        let redirectCase = UtilService.checkIfRedirectCase()
        if (redirectCase) {
            message_comp.setState({ redirectCase: true })

            let new_messages = []
            message_comp.showHistoryMessages();
            message_comp.scrollToBottom();

            if (redirectCase === "changePlanRedirectCase") {
                if (UtilService.getParamValue("changePlanStatus") === "true") {
                    new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.PLAN_CHANGE_SUCCESS))
                }
                else {
                    new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.PLAN_CHANGE_FAIL))
                }
            }
            else if (redirectCase === "paymentTransactionRedirectCase") {
                if (UtilService.getParamValue("transactionStatus") === "success") {
                    let success_message = createPaymentSuccessMessage();
                    new_messages.push(UtilService.createChatBotMessageObject(success_message));
                }
                else if (UtilService.getParamValue("transactionStatus") === "failure") {
                    new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.PAYMENT_FAIL))
                }
                else {
                    new_messages.push(UtilService.createChatBotMessageObject(SCRIPTS.PAYMENT_PENDING))
                }

            }

            message_comp.addNewMessages({ new_messages })
            if (UtilService.getParamValue("n")) {
                GlobalStoreService.set("currentNumber", UtilService.getParamValue("n"))
            }
            else {
                GlobalStoreService.set("currentNumber", GlobalStoreService.get("primaryNumber"))
            }
        }

        else {

            //normal first come case
            if (GlobalStoreService.get('userProfileType') === 'SINGLE') {
                //handle single account login
                GlobalStoreService.set("currentNumber", GlobalStoreService.get("primaryNumber"))
                if (data && data.length > 0) {
                    message_comp.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME_BACK)] })
                    message_comp.onNumberSelected({ user_response: GlobalStoreService.get("primaryNumber"), show_number: false });
                }

                else {
                    message_comp.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME)] })
                    message_comp.onNumberSelected({ user_response: GlobalStoreService.get("primaryNumber"), show_number: false });
                }


            }
            else if (GlobalStoreService.get('userProfileType') === 'MULTIPLE') {
                // handle multiple account login

                if (data && data.length > 0) {

                    message_comp.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU })
                    message_comp.setLoaderOff();
                    message_comp.addNewMessages({
                        new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME_BACK),
                        UtilService.createChatBotMessageObject(SCRIPTS.SELECT_ACCOUNT)]
                    })

                    // WHEN AVATAR OF BOT WILL BE RELEASED                                       
                    // message_comp.addNewMessages({new_messages:[{component_type:'WELCOME_COMPONENT_MULTIPLE',message:SCRIPTS.WELCOME_BACK,messageTime:UtilService.getCurrentTime()}]})

                }
                else {
                    message_comp.setBottomBarComponentState({ type: globalConstants.BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU })
                    message_comp.setLoaderOff();
                    message_comp.addNewMessages({
                        new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.WELCOME),
                        UtilService.createChatBotMessageObject(SCRIPTS.SELECT_ACCOUNT)]
                    })

                    // WHEN AVATAR OF BOT WILL BE RELEASED
                    // message_comp.addNewMessages({new_messages:[{component_type:'WELCOME_COMPONENT_MULTIPLE',message:SCRIPTS.WELCOME,messageTime:UtilService.getCurrentTime()}]})

                }
            }
            else {
                //handle no account case
                message_comp.addNewMessages({ new_messages: [UtilService.createChatBotMessageObject(SCRIPTS.DEFAULT_ERROR)] })
            }

        }
    }

}

const createDateMessageComponentObject = (date) => {
    return {
        component_type: 'HISTORY_DATE_COMPONENT',
        message: date
    }
}

const createPaymentSuccessMessage = () => {
    let number = UtilService.getParamValue("n")
    let transactionId = UtilService.getParamValue("transactionId")
    let transactionAmount = UtilService.getParamValue("amt")
    let transactionDate = UtilService.getParamValue("transactionDate")
    let message = `Yay ! Your transaction was successful. 
                ${(number || transactionAmount || transactionDate || transactionId ? `Here are your payment details:<br>` : ``)}
                ${(number ? `Mobile Number : ${number} <br>` : ``)}
                ${(transactionAmount ? `Amount Paid: Rs ${transactionAmount}<br>` : ``)}
                ${(transactionId ? `Transaction Id: ${transactionId}<br>` : ``)}
                ${(transactionDate ? `Transaction Date: ${transactionDate}` : ``)}`

    return message
}

const createHistoryMessageDateArray = (data, oldHistoryMessages) => {
    // console.log(data)
    let chatHistoryNewMessages = []
    //filter the old history messages to remove history component messages to compare timestamp of messages
    let filteredOldHistoryMessages = oldHistoryMessages && oldHistoryMessages.length > 0 ? oldHistoryMessages.filter(message => message.component_type !== 'HISTORY_DATE_COMPONENT') : []
    data.map((message_obj, index) => {
        try {
            let currentMessageDate = new Date(JSON.parse(message_obj.content).messageTime.timestamp)
            if (index > 0 || filteredOldHistoryMessages.length > 0) {
                let previousMessageDate = index > 0 ? new Date(JSON.parse(data[index - 1].content).messageTime.timestamp) : new Date(filteredOldHistoryMessages[0].messageTime.timestamp)
                // console.log((getDateInFormat(previousMessageDate)),(getDateInFormat(currentMessageDate)))
                if (areDatesSame(currentMessageDate, previousMessageDate)) {
                    // console.log('messages same date')

                    // if dates are same for the data message and first history message remove the history date component
                    if (index === 0) {
                        oldHistoryMessages = oldHistoryMessages.filter((message, index) => !(message.component_type === "HISTORY_DATE_COMPONENT" && index === 0))
                    }
                    else {

                    }
                }
                else {
                    // console.log('messages date not same')
                    // console.log(getDateInFormat(previousMessageDate))

                    chatHistoryNewMessages.push(createDateMessageComponentObject(getDateInFormat(previousMessageDate)))
                }
            }
            message_obj = JSON.parse(message_obj.content)
            message_obj['fromHistory'] = true
            chatHistoryNewMessages.push(message_obj)
            if (index === data.length - 1) {
                chatHistoryNewMessages.push(createDateMessageComponentObject(getDateInFormat(currentMessageDate)))
            }

        }
        catch (e) {
            console.log('couldnt parse the message', data, e)
        }
    })
    return { chatHistoryNewMessages: chatHistoryNewMessages.reverse(), chatHistoryOldMessages: oldHistoryMessages }
}

const getDateInFormat = (date) => {
    let months = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'August', 'Sept', 'Oct', 'Nov', 'Dec']
    let day = date.getDate()
    let month = months[date.getMonth()]
    let year = date.getFullYear();

    let dateToday = new Date();
    let dayToday = dateToday.getDate();
    let monthToday = months[dateToday.getMonth()]
    let yearToday = dateToday.getFullYear();


    if (dayToday === day && monthToday === month && yearToday === year) {
        return 'TODAY'
    }
    else if (dayToday - 1 === day && monthToday === month && yearToday === year) {
        return 'YESTERDAY'
    }
    else {
        return `${day} ${month}, ${year}`
    }

}

const areDatesSame = (currentDate, previousDate) => {
    if (currentDate.getDate() === previousDate.getDate()) {
        if (currentDate.getMonth() === previousDate.getMonth()) {
            if (currentDate.getFullYear() === previousDate.getFullYear()) {
                return true
            }
            else {
                return false
            }
        }
        else {
            return false
        }
    }
    else {
        return false
    }
}

export { handleReadReturnFromDB }


// WEBPACK FOOTER //
// ./src/services/handle-chat-history-from-db.service.js